module.exports = __webpack_public_path__ + "img/tour-38.1e0ea4a5.png";